var styles = {"cover":"styles_cover__uV65m"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
